export default __webpack_public_path__ + "static/media/whatsapp.ac285bb7.svg";